import styled from '@emotion/styled'
import { Form } from 'antd'

export const StyledForm = styled(Form)`
  .ant-input-affix-wrapper,
  .ant-input-number,
  .ant-select-single .ant-select-selector,
  .ant-picker {
    height: 40px;
    background-color: transparent !important;
    border-color: #4a4a4a;
    color: #8d8f91;
    line-height: 38px;
    &::placeholder {
      font-size: 12px;
      color: #888888;
    }
  }
  .ant-form-item-has-error .ant-input {
    background-color: transparent !important;
    &:hover {
      background-color: transparent !important;
    }
  }
  .ant-input-suffix {
    right: 6px;
    button {
      font-size: 12px;
      line-height: 26px;
      height: 26px;
      color: var(--main-color);
      background-color: transparent;
      border-color: var(--main-color);
      padding: 0 10px;
      &:disabled {
        color: rgba(0, 0, 0, 0.25);
        background-color: #f5f5f5;
        border-color: #d9d9d9;
      }
    }
  }
  button[type='submit'] {
    background-color: var(--main-color);
    border-color: var(--main-color);
    color: #fff;
    &:hover {
      background-color: var(--main-color);
      border-color: var(--main-color);
    }
  }
  .ant-checkbox-wrapper {
    font-size: 12px;
    color: #999999;
    a {
      color: #666666;
    }
    .ant-checkbox-inner {
      background-color: transparent;
      border-color: var(--main-color);
      &:after {
        border-color: var(--main-color);
      }
    }
    .ant-checkbox-checked:after {
      border-color: var(--main-color);
    }
  }
  .ant-col-6 {
    max-width: 100%;
    flex-basis: auto;
    margin-right: 10px;
  }
  .ant-form-item-label {
    line-height: 24px;
    > label {
      color: #d3d3d2;
    }
  }
  .ant-form-item-control {
    color: #fff;
    line-height: 24px;
  }
  .ant-input-number-handler-wrap {
    background-color: transparent;
    border-color: #4a4a4a;
    span {
      border-color: #4a4a4a;
      color: #ffffff;
    }
  }
  .ant-input-number input,
  .ant-select-single {
    .ant-select-selection-search input {
      height: 38px;
    }
    .ant-select-selector .ant-select-selection-item {
      line-height: 38px;
    }
    .ant-select-clear {
      background-color: transparent;
    }
  }

  &.ant-form-inline {
    .ant-form-item-label {
      line-height: 40px;
    }
    button[type='submit'] {
      height: 40px;
      padding: 0 24px;
    }
  }
  .ant-radio-wrapper {
    font-size: 14px;
    color: #fff;
    &-checked,
    &:hover,
    &:focus {
      .ant-radio-inner {
        border-color: var(--main-color);
      }
    }
  }
  .ant-radio {
    &:hover {
      .ant-radio-inner {
        border-color: var(--main-color);
      }
    }
  }
  .ant-radio-inner {
    background-color: transparent;
    border-color: #979797;
    &:after {
      background-color: var(--main-color);
    }
    &:hover {
      border-color: #979797;
    }
  }
  .ant-upload {
    button {
      background-color: transparent;
      color: var(--main-color);
      border-color: var(--main-color);
      .anticon {
        color: var(--main-color);
      }
    }
  }
  .ant-upload-list {
    color: #fff;
  }
  .ant-upload-list-item:hover .ant-upload-list-item-info {
    background-color: transparent;
  }
  textarea.ant-input {
    height: auto;
  }
  .ant-picker-separator {
    color: #fff;
  }
  .ant-input-affix-wrapper {
    padding: 0 11px;
  }
  .ant-input {
    background-color: transparent;
    color: #8d8f91;
    border-color: #404040;
  }
`
export const StyledFormItem = styled(Form.Item)``
